export const GET_CLIENTS_REQUEST = "GET_CLIENTS_REQUEST"
export const GET_CLIENTS_SUCCESS = "GET_CLIENTS_SUCCESS"
export const GET_CLIENTS_FAILURE = "GET_CLIENTS_FAILURE"
export const GET_NEXT_PAGE_CLIENTS_REQUEST = "GET_NEXT_PAGE_CLIENTS_REQUEST"
